import { formatFileObject } from '@plandi/common'

export const getPartsForFormattedRequest = (parts?: Array<{ name?: string }>) =>
  (parts ?? [])
    ?.filter((part): part is { name: string } => !!part?.name)
    .map((part) => part.name)

export const getPartsForFormattedForm = (parts?: string[]) =>
  (parts ?? [])?.map((part) => ({ name: part }))

export const getImagesForFormattedForm = (
  cover?: { id?: number; url?: string } | null,
  images?: Array<{ id?: number; url?: string }>
) => ({
  images: images
    ?.filter((image): image is { url: string } => Boolean(image.url))
    .map((image) => formatFileObject(image.url)),
  cover: cover?.url ? formatFileObject(cover?.url) : undefined
})
